import React from 'react';
import { SeasonPlayerRanking } from '../../../types/types';
import { STAT_ORDER, STAT_LABELS } from './achievementUtils';
import Medal from './Medal';

interface SeasonRowProps {
    season: number;
    rankings: SeasonPlayerRanking[];
}

const SeasonRow: React.FC<SeasonRowProps> = ({ season, rankings }) => {
    const rankingMap = new Map<string, SeasonPlayerRanking>();
    for (const r of rankings) {
        rankingMap.set(r.stat, r);
    }

    return (
        <div className="season-section">
            <div className="season-section__header">
                <span className="season-section__number">Saeson {season}</span>
                <div className="season-section__line" />
            </div>
            <div className="season-section__medals">
                {STAT_ORDER.map((stat) => {
                    const ranking = rankingMap.get(stat);
                    if (!ranking) {
                        const statLabel = STAT_LABELS[stat];
                        return (
                            <div key={stat} className="medal medal--empty">
                                <div className="medal__hex" style={{ width: 58, height: 58 }}>
                                    <span className="medal__rank">-</span>
                                </div>
                                <div className="medal__label">
                                    {statLabel?.short || stat}
                                </div>
                            </div>
                        );
                    }

                    return (
                        <Medal
                            key={stat}
                            rank={ranking.rank}
                            totalPlayers={ranking.totalPlayers}
                            stat={ranking.stat}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default SeasonRow;
